// extracted by mini-css-extract-plugin
module.exports = {"optionstitle":"index-styles_optionstitle__qVD54","optionsconteiner":"index-styles_optionsconteiner__2qWJL","optionsbutton":"index-styles_optionsbutton__1s0V-"};